parasails.registerPage('new-member-password', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    overallEventID: '',
    formData: { },
    showFooter: true,
    useDarkLogos: true,
    // For tracking client-side validation errors in our form.
    // > Has property set to `true` for each invalid property in `formData`.
    formErrors: { /* … */ },

    // Form rules
    formRules: {
      password: {
        required: true,
        custom: (value) => {
          // Check for minimum length
          if (value.length < 8) {
            return false;
          }
          // Check for at least one uppercase letter
          if (!/[A-Z]/.test(value)) {
            return false;
          }
          // Check for at least one lowercase letter
          if (!/[a-z]/.test(value)) {
            return false;
          }
          // Check for at least one number
          if (!/[0-9]/.test(value)) {
            return false;
          }
          return true;
        }
      },
      confirmPassword: {required: true, sameAs: 'password'},
      eventID: {required: false}
    },
    // Syncing / loading state
    syncing: false,
    // Server error state
    cloudError: '',
    // Success state when form has been submitted
    cloudSuccess: false,
    showPassword: false,
    eventLogo: '../images/caramel-logo.png',
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function() {
    //…
  },
  mounted: async function() {
    const urlParams = new URLSearchParams(window.location.search);
    this.overallEventID = urlParams.get('eventID');
    this.formData.token = this.token;
    this.formData.eventID = this.overallEventID;
    this.setLogo();
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    setLogo() {
      if(this.eventData.logoImage) {
        this.eventLogo = this.eventData.logoImage;
      }
      if(this.eventData.subLogoImage) {
        this.subLogo = this.eventData.subLogoImage;
      }
    },
    submittedForm: async function() {
      // Redirect to the logged-in dashboard on success.
      // > (Note that we re-enable the syncing state here.  This is on purpose--
      // > to make sure the spinner stays there until the page navigation finishes.)
      this.syncing = true;
      this.cloudSuccess = true;
      setTimeout(() => {
        window.location = '/memberlogin?eventID=' + this.overallEventID;
      }, 3000);
    },
  }
});
